import React from 'react';
import PropTypes from 'prop-types';
import { ProjectBased } from './styles';
import Image from '../Image';

const Project = ({ id, title, link, src, alt }) => (
  <ProjectBased id={id}>
    <p>{title}</p>
    <a href={link} target='_blank'>
      <Image src={src} alt={alt} />
    </a>
  </ProjectBased>
);

Project.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  title: PropTypes.string,
  link: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
};

export default Project;
